import { Style, RegularShape, Stroke, Fill, Circle, Text } from 'ol/style';
import { Icon } from 'ol/style.js';
import IcoCircle from '../../assets/images/map/ico-circle.png';
import IcoCircleActive from '../../assets/images/map/ico-circle-active.png';
import IcoSquare from '../../assets/images/map/ico-square.png';
import IcoSquareActive from '../../assets/images/map/ico-square-active.png';
import IcoTriangle from '../../assets/images/map/ico-triangle.png';
import IcoTriangleActive from '../../assets/images/map/ico-triangle-active.png';
import IcoPhoto from '../../assets/images/map/ico-photo.png';
import IcoPhotoActive from '../../assets/images/map/ico-photo-active.png';

export const getImage = (shp, isActive) => {
  const images = {
    circle: new Icon({
      src: isActive ? IcoCircleActive : IcoCircle,
      scale: 1,
      anchor: isActive ? [20.5, 21.5] : [14.5, 15.5],
      anchorXUnits: 'pixels',
      anchorYUnits: 'pixels',
    }),
    square: new Icon({
      src: isActive ? IcoSquareActive : IcoSquare,
      scale: 1,
      anchor: isActive ? [20.5, 21.5] : [14.5, 15.5],
      anchorXUnits: 'pixels',
      anchorYUnits: 'pixels',
    }),
    triangle: new Icon({
      src: isActive ? IcoTriangleActive : IcoTriangle,
      scale: 1,
      anchor: isActive ? [20.5, 21.5] : [14.5, 15.5],
      anchorXUnits: 'pixels',
      anchorYUnits: 'pixels',
    }),
    photo: new Icon({
      src: isActive ? IcoPhotoActive : IcoPhoto,
      scale: 1,
      anchor: isActive ? [20.5, 21.5] : [14.5, 15.5],
      anchorXUnits: 'pixels',
      anchorYUnits: 'pixels',
    }),
  };
  return images[shp];
};

// [shp] : circle, square, triangle
export const shapeStyle = (feature, shp) => {
  const properties = feature?.getProperties();

  const text = properties?.a5 || '-'; // GeoServer 도근점명

  return [
    new Style({
      image: getImage(shp, false),
      text: new Text({
        text: String(text),
        font: '600 12px Pretendard',
        stroke: new Stroke({
          color: '#000',
          width: 1,
        }),
        fill: new Fill({ color: '#ffffff' }),
        offsetY: 10,
      }),
    }),
  ];
};

// with text
export const withTextStyle = (feature, isActive = false) => {
  let properties = feature?.getProperties();

  let shp = '';
  let color = '';
  let txt = '';

  if (properties.properties.BASE_NAME === '지적도근점') {
    shp = 'circle';
    color = '#ff7700ff';
    txt = properties?.lgstr_splmcpt_idntfc_nm || properties?.a5; // 도근점
  }
  if (properties.properties.BASE_NAME === '지적삼각보조점') {
    shp = 'square';
    color = '#55ff00';
    txt = properties?.lgstr_tgspt_idntfc_nm; // 삼각보조점
  }
  if (properties.properties.BASE_NAME === '지적삼각점') {
    shp = 'triangle';
    color = '#00fffb';
    txt = properties?.lgstr_trgltpt_no_nm; // 삼각점
  }

  let text = new Text({
    text: String(txt),
    font: '600 12px Pretendard',
    fill: new Fill({ color: '#ffffff' }),
    stroke: new Stroke({
      color: '#000',
      width: 1,
    }),
    offsetY: 13,
  });

  return [
    new Style({
      image: getImage(shp, isActive),
      text: text,
      zIndex: isActive ? 2 : 1,
    }),
  ];
};
export const withTextStyle2 = (feature, type, isActive = false) => {
  let properties = feature?.getProperties().properties;

  let shp = '';
  let color = '';
  let txt = '';

  if (type === 'dogeun') {
    shp = 'circle';
    color = '#ff7700ff';
    txt = properties?.DOGEUN_POI || properties?.a5; // 도근점
  }
  if (type === 'aux_triangle') {
    shp = 'square';
    color = '#55ff00';
    txt = properties?.TRAG_ASSTC || properties?.a5; // 삼각보조점
  }
  if (type === 'triangle') {
    shp = 'triangle';
    color = '#00fffb';
    txt = properties?.TRAG_POINT || properties?.a5; // 삼각점
  }

  let text = new Text({
    text: String(txt),
    font: '600 12px Pretendard',
    fill: new Fill({ color: '#ffffff' }),
    stroke: new Stroke({
      color: '#000',
      width: 1,
    }),
    offsetY: 13,
  });

  return [
    new Style({
      image: getImage(shp, isActive),
      text: text,
      zIndex: isActive ? 2 : 1,
    }),
  ];
};
